import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { MedicalOrderDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';

import { MedicalOrderDto } from 'src/app/shared/models/medical-order/medical-order-dto';
import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class MedicalOrderWorkItem extends WorkItem<MedicalOrderDto> {
  constructor(@Inject(UnitOfWorkFactory) _unitOfWorkFactory: IUnitOfWorkFactory) {
    super(_unitOfWorkFactory);
  }

  get name(): string {
    return 'MedicalOrderWorkItem';
  }
  get database(): string {
    return MedicalOrderDB;
  }
}
